import { useQuery } from "@tanstack/react-query";
import type { VehicleModel } from "@spare-cart/contracts/vehicles";
import { apiClient, toQueryRecord } from "@core/api";

export const useVehicleModelsByMake = (makeId: string | undefined) =>
  useQuery({
    queryKey: ["shared", "vehicle-models-by-make", makeId],
    queryFn: () =>
      apiClient.list<VehicleModel>("/vehicle-models", {
        query: toQueryRecord({ page: 1, limit: 100, makeId, isActive: "true" }),
      }),
    enabled: makeId !== undefined,
  });
